module.exports = __webpack_public_path__ + "img/制御工学7_4.bde77139.png";